module.exports = __webpack_public_path__ + "static/browser_wahl_small-79ca534cd66ec7ec80667e51810f149d.png";